import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV2 } from "../endpoints/m2m-cleaning.cleaner-v2"

interface CheckItemList {
    items: { title: string }[]
}

export const useCheckItems = (token: string, cleaningId: string) => {
    return useAuthBearerFetch<CheckItemList>(
        token,
        m2mCleaning_cleanerV2.getCheckitems({ cleaningId }),
        {}
    )
}
